import { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import { userUpdateRequest } from '../../actions/user';
import { signOutUser } from '../../actions/user';

import { Anchor } from '../Anchor';
import { Button } from '../Button';

import { getUser } from '../../selectors/user';
import qs from 'qs';

export const MigratePrivacy: FunctionComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(getUser);

  const { update_privacy, marketing_check } = qs.parse(
    window.top?.location.search.slice(1) || ''
  );

  const signOut = useCallback(() => {
    dispatch(signOutUser());
    navigate('/');
  }, [dispatch, navigate]);

  const onPrivacyAccepted = useCallback(() => {
    const { password, ...data } = user.data!;

    dispatch(
      userUpdateRequest({
        ...data,
        privacyChecked: '2',
      })
    );
  }, [dispatch, user]);

  return (
    <Modal
      show={
        user.data!.privacyChecked === '1' &&
        update_privacy !== '2' &&
        marketing_check !== '1'
      }
    >
      <Modal.Header>Aggiornamento privacy policy</Modal.Header>

      <Modal.Body>
        Gentile utente, Abbiamo aggiornato la nostra informativa privacy,
        disponibile{' '}
        <Anchor href={'https://www.lagostina.it/it/privacy'}>qui</Anchor>: per
        continuare ad utilizzare l’Area Members è necessario prenderne visione.
        Cliccando il tasto “Conferma” dichiari di aver letto e compreso la
        nostra nuova informativa privacy.
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={signOut} variant={'secondary'}>
          Esci
        </Button>
        <Button onClick={onPrivacyAccepted}>Conferma</Button>
      </Modal.Footer>
    </Modal>
  );
};
